var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverage"},[_c('div',{staticClass:"map-container"},[_c('coverage-map2')],1),_vm._v(" "),_c('div',{staticClass:"sector-list"},[_c('sector-list')],1),_vm._v(" "),_c('coverage-shift-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f920109","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coverage/index.vue
// module id = 2025
// module chunks = 0